export default __webpack_public_path__ + "static/agency-5858f3011ddb46e06b272e4aafb7cf64.svg";